import * as React from "react";
import { forwardRef } from "react";
const SvgArrowTopDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	fill: "currentColor",
	height: "1em",
	viewBox: "0 0 9 15",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M9 5.57141L4.5 0L0 5.57141L3.58333 5.57141L3.58333 9.42859H0L4.5 15L9 9.42859H5.41667L5.41667 5.57141L9 5.57141Z" }));
const ForwardRef = forwardRef(SvgArrowTopDown);
export default ForwardRef;
